import { request } from 'util/request';

async function getRoutes(shiftIDs: any) {
  return request(`delivery/routes/${shiftIDs}`);
}

export { getRoutes }
